{
  "confirmationNumber": "Номер підтвердження {number}",
  "dateTimeRange": "{date} з {startTime} до {endTime}"
}
